import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { ModalController } from '../modal-controller/modal-controller.service';
import { SingleImageLoaderComponent } from '../../components/modal/single-image-loader/single-image-loader.component';


@Injectable({
  providedIn: 'root'
})
export class SingleImageLoaderController extends ModalController {
  
  constructor(    
    private componentFactoryResolverSingle: ComponentFactoryResolver,
    private applicationRefSingle: ApplicationRef,
    private injectorSingle: Injector ) 
    {
    super(componentFactoryResolverSingle, applicationRefSingle, injectorSingle);
  }

  createSingleModal( title:string, imageLoader: {
    onSave: Function
  }) {
    super.create({
      title,
      content: {
        component: SingleImageLoaderComponent,
        props: imageLoader
      },
    });
  }
  
  present() {
    return super.present();
  }
}


